module.exports = "https://web-assets.ifttt.com/packs/media/icons/hail-421ebe44.png";